import React, { useState, useCallback, useMemo } from 'react';
import { Box, Toolbar } from '@mui/material';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const DRAWER_WIDTH_EXPANDED = 260;
const DRAWER_WIDTH_COLLAPSED = 72;

const MainLayout = ({ children }) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(true);

    const handleDrawerToggle = useCallback(() => {
        setMobileOpen(prev => !prev);
    }, []);

    const handleSidebarCollapse = useCallback(() => {
        setSidebarCollapsed(prev => !prev);
    }, []);

    const currentWidth = useMemo(
        () => sidebarCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH_EXPANDED,
        [sidebarCollapsed]
    );

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', overflow: 'hidden' }}>
            <TopBar
                width={currentWidth}
                onDrawerToggle={handleDrawerToggle}
                onSidebarCollapse={handleSidebarCollapse}
                sidebarCollapsed={sidebarCollapsed}
            />

            <Sidebar
                width={currentWidth}
                mobileOpen={mobileOpen}
                onDrawerToggle={handleDrawerToggle}
                collapsed={sidebarCollapsed}
                onCollapse={handleSidebarCollapse}
            />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    minHeight: '100vh',
                    backgroundColor: '#FAFBFC',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                }}
            >
                <Toolbar sx={{ minHeight: '56px !important' }} />
                {children}
            </Box>
        </Box>
    );
};

export default MainLayout;
